export default {
    patients: [],
    practitioners: [],
    loading: false,
    loadingError: null
}



// WEBPACK FOOTER //
// ./src/redux/reducers/persona/init.js